import React, {useEffect} from 'react';
import ReportUtils from "../../../../../utils/report-utils.js";
import GraphicUtils from "../../../../../utils/graphic-utils.js";

const TimeLineContent = ({ data, startDate, endDate }) => {

    const lines = [
        {
            id: 'alarms-by-hour',
            title: 'Alarmes por intervalo de hora',
            data: data?.apply?.by_hour,
            exportTitle: 'Alarmes por intervalo de hora',
            customTitle: 'Intervalo de hora',
            formatter: (value) => value.text + 'h'
        },
        {
            id: 'alarms-by-day',
            title: 'Alarmes por dia',
            data: data?.apply?.by_day,
            exportTitle: 'Alarmes por dia',
            customTitle: 'Dia',
            formatter: (value) => value?.text != null ? String(value.text).padStart(2, '0') : ''
        }
    ];

    useEffect(() => {

        lines.forEach(lines => {
            if (!lines.data) return;

            const labels = [];
            const values = [];

            lines.data.forEach(element => {
                labels.push(lines.formatter(element));
                values.push(element.qty);
            });

            GraphicUtils.lineChart(lines.id, [['Alarmes', ...values]], labels, false);
            labels.length > 0 && ReportUtils.createExportableTable(labels, values, lines.exportTitle, null, [lines.customTitle, "Quantidade"]);

        });

    }, [data]);

    const renderedLines = [];

    for (let index = 0; index < lines.length; index++) {
        const currentLine = lines[index];

        renderedLines.push(
            <React.Fragment key={currentLine.id}>

                <div className="chart-report">
                    <span className="chart-title">{currentLine.title}</span>
                    <div className="mt-3" id={currentLine.id}></div>
                </div>

                { currentLine.id === 'alarms-by-day' &&
                    <div className="obs-warn">* Valores acumulados pelos mesmos dias dentro dos meses entre {ReportUtils.formatDateOnly(startDate)} e {ReportUtils.formatDateOnly(endDate)}.</div>
                }

                <div className="chart-divisor print:hidden"/>

            </React.Fragment>
        );
    }

    return (
        <>
            {renderedLines}
        </>
    );
};

export default TimeLineContent;